module.exports = __webpack_public_path__ + "static/img/LxdsjfxptV1.ad56365a.png";